import { type SerializedPageStructure } from '@wix/document-services-types'
import { BUTTON_ROLE } from '@wix/wix-data-client-common-standalone'

import {
  modifyConnectionConfigOfComponentAndControllerWithVeloIds,
  setConnectionConfigPropertyField,
} from './utils'
import { FILTER_DATASET_VELO_ID } from './veloIds'

export const rebindSelectItemAction = ({
  page,
  pageLinkFieldKey,
}: {
  page: SerializedPageStructure
  pageLinkFieldKey: string
}): SerializedPageStructure =>
  modifyConnectionConfigOfComponentAndControllerWithVeloIds({
    page,
    componentVeloId: 'selectItemAction',
    controllerVeloId: FILTER_DATASET_VELO_ID,
    role: BUTTON_ROLE,
    modifyConnectionConfig: config =>
      setConnectionConfigPropertyField({
        config,
        propertyName: 'link',
        fieldKey: pageLinkFieldKey,
      }),
  })
